import { put } from 'helpers/api';

export const SAVE_STARTED = 'SAVE_STARTED';
function saveStarted() {
  return {
    type: SAVE_STARTED,
  };
}

export const SET_SETTINGS = 'SET_SETTINGS';
function setSettings(settings) {
  return {
    type: SET_SETTINGS,
    allowDeals: settings.allowDeals,
    royaltyPercent: settings.royaltyPercent,
  };
}

export function savePropertyManagementSettings(settings) {
  return (dispatch, getState) => {
    dispatch(saveStarted());

    const { paths } = getState();

    const body = {
      company: {
        allowPropertyManagementDeals: settings.allowDeals,
        propertyManagementRoyaltyPercent: settings.royaltyPercent,
      },
    };

    return put(paths.propertyManagement, body)
      .then(() => {
        dispatch(setSettings(settings));
      });
  };
}
